import React from "react";
import { withTranslation } from "react-i18next";
import { observer, inject } from "mobx-react";
import {
	Button,
	Menu,
	Modal,
	Icon,
	Dropdown,
	Form,
} from "semantic-ui-react";
import moment from "moment";
import { SingleDatePicker } from "react-dates";

class BoskalisExport extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			filter: "",
			kol: "",
			amas: [],
			amamode: false,
			focused: false,
			start: moment().startOf("day"),
		};
	}

	open() {
		this.setState({ open: true });
	}

	close() {
		this.setState({ open: false, filter: "" });
	}

	render() {
		const suppliers = [];
		for (let supplier of this.props.app.basedata.suppliers.values()) {
				if (supplier.deleted || supplier.shortname === "") continue;
				suppliers.push({ value: supplier.shortname, key: supplier.id, "text": supplier.shortname });
			}

		return (
			<Modal
				centered={false}
				className="duravermeerModal"
				trigger={
					<Button icon="file excel outline" onClick={(e) => this.open()} />
				}
				open={this.state.open}
				onClose={(e) => this.close()}
			>
				<React.Fragment>
					<Menu>
						<Menu.Item header>{this.props.t("exports.heading")}</Menu.Item>

						<Menu.Menu position="right">
							<Menu.Item name="close it" onClick={(e) => this.close()}>
								<Icon name="close" />
							</Menu.Item>
						</Menu.Menu>
					</Menu>
					<Modal.Content>
						<Form as="div">
						
							<Form.Field>
								<label>{this.props.t("exports.start")}</label>
								<SingleDatePicker
									date={this.state.start} // momentPropTypes.momentObj or null,
									id="xdpicker_start" // PropTypes.string.isRequired,
									numberOfMonths={3}
									isOutsideRange={(x) => false}
									onDateChange={(date) =>
										this.setState({
											start: date,
										})
									} // PropTypes.func.isRequired,
									focused={this.state.focused} // PropTypes.bool
									onFocusChange={({ focused }) => this.setState({ focused })}
									hideKeyboardShortcutsPanel
								/>
							</Form.Field>
							<Form.Field><label>Type</label>
							<Dropdown selection options={[{
								key: "normal",
								value: "normal",
								text: "APS"
							}]} value={this.state.amamode ? "amamode" : "normal"} onChange={(a,{value}) => this.setState({amamode: value === "amamode"})} />
							</Form.Field>
							{this.state.amamode ? (<Form.Field><label>Asfaltcentrales</label>
							<Dropdown selection multiple search placeholder="Selecteer alstublieft..." options={suppliers} value={this.state.amas} onChange={(a,{value}) => this.setState({amas: value})} />
							</Form.Field>) : null}
							<Form.Field><label>Vestiging</label>
							<Dropdown selection placeholder="Alles" options={[{
								key: "all",
								value: "",
								text: "Alles"
							}]} value={this.state.kol} onChange={(a,{value}) => this.setState({kol: value})} />
							</Form.Field>
						</Form>
						<form
							className="hiddenForm"
							method="get"
							action={""+process.env.REACT_APP_BPO_URL+"/ressourcen/boskalisplan.php"}
							target="_blank"
						>
							<input
								type="hidden"
								name="start"
								value={this.state.start.format("YYYY-MM-DD")}
							/>
							{this.state.amamode ? <input type="hidden" name="amaselect" value={this.state.amas.join(",")} /> : null}
							<input type="hidden" name="kol" value={this.state.kol} />
							<Button positive fluid>
								{this.props.t("exports.get")}
							</Button>
						</form>
					</Modal.Content>
				</React.Fragment>
			</Modal>
		);
	}
}

export default withTranslation()(inject("app")(observer(BoskalisExport)));
